import { useState } from 'react';
import styled from 'styled-components';
import { Checkbox, Box, Typography } from '@mui/material';
import { Timer } from '@mui/icons-material';
import COLORS from '../../colors';

interface HorizontalListItemProps {
  text: string;
  checked: boolean;
  onChange: () => void;
}

interface StyledBoxProps {
  checked: boolean;
}

const StyledBox = styled(Box)<StyledBoxProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) =>
    props.checked ? COLORS.CHECKED : COLORS.NEUTRAL_900};
  padding: 8px 16px;
  border-radius: 12px;
  cursor: pointer;
`;

const StyledTimer = styled(Timer)<StyledBoxProps>`
  color: ${(props) =>
    props.checked ? COLORS.ON_PRIMARY_CONTAINER : 'inherit'};
  margin-right: 8px;
`;

const HorizontalListItem = ({
  text,
  checked,
  onChange
}: HorizontalListItemProps) => {
  const handleChange = (): void => {
    onChange();
  };

  return (
    <StyledBox checked={checked} onClick={handleChange}>
      <Box display="flex" alignItems="center">
        <StyledTimer checked={checked} />
        <Typography variant="body1" sx={{ color: 'white' }}>
          {text}
        </Typography>
      </Box>
      <Checkbox sx={{ color: COLORS.NEUTRAL_200 }} checked={checked} />
    </StyledBox>
  );
};

export default HorizontalListItem;
